module.exports = __webpack_public_path__ + "img/icon-printer.732a936b.svg";